import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import _ from "lodash";
import {getCurrentMicroTime} from "../../../../reducers/timeMeasuring/actions";
import DragDrop from "./DragDrop";
import QuestionContainer from "../Components/questionContainer";

class Basket extends Component {

  constructor(props) {
    super(props);

    this.handlerDrop = this.handlerDrop.bind(this);
  }

  handlerDrop(basket, answer, content = undefined){
    const {details} = this.props;
    const microTime = getCurrentMicroTime(this.props.startTime);

    const detail = {
      answer,
      basket,
      content,
      microTime,
    };

    if (basket) {
      this.props.onDetailsUpdated([
        ...details.filter(d => d.answer !== answer),
        detail
      ]);
    } else {
      this.props.onDetailsUpdated([
        ...details.filter(d => d.answer !== answer)
      ]);
    }
  }

  validate(){
    const {details, question, validationTexts} = this.props;

    let validate = {
      valid: true,
      errors: []
    };

    if (details.length < question.answersMin) {
      validate.errors.push(validationTexts.requiredMinimumAnswers);
    }

    if(question.requiredAll && details.length < question.answers.length){
      validate.errors.push(validationTexts.requiredAll);
    }

    details.map(detail => {
      const answer = question.answers.find(answer => parseInt(answer.id) === parseInt(detail.answer));

      if(answer.isOpen && !answer.openIsNotRequired && !detail.content){
        validate.errors.push(validationTexts.detail.answerContentEmpty);
      }
    })

    validate.valid = _.isEmpty(validate.errors);

    return validate;
  }

  render(){
    const {details, question} = this.props;

    return (
        <QuestionContainer
          component={<DragDrop question={question} details={details} handleDrop={this.handlerDrop} />}
        />
    )
  }
}

Basket.propTypes = {
  question: PropTypes.shape({
    answers: PropTypes.array.isRequired,
    baskets: PropTypes.array.isRequired,
  }).isRequired,
  details: PropTypes.arrayOf(PropTypes.shape({
    answer: PropTypes.number.isRequired,
    basket: PropTypes.number.isRequired,
    microTime: PropTypes.number.isRequired,
  })),
  id: PropTypes.number.isRequired,
  onDetailsUpdated: PropTypes.func.isRequired,
  validationTexts: PropTypes.shape({
    requiredMinimumAnswers: PropTypes.string.isRequired,
  //   detail: PropTypes.shape({
  //
  //   }),
  }),
};

function mapStateToProps(state) {
  return {
    startTime: state.timeMeasuring.startTime,
  }
}

export default connect(mapStateToProps, null, null, {withRef: true, forwardRef: true})(Basket);